export default {
  usuario: {},
  empresa: {},
  empresas: {},
  empresasSelecionadas: [],
  especialistaOperacional: {},
  especialistaComercial: {},
  tiposUsuario: [],
  listaEmailsMesmoDomain: [],
  versaoTrinity: '',
  teamTrinity: [],
  lastFetchNotifications: null,
};
